var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFjdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 19,
    viewBox: "0 0 47 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9763 13.1659C16.9778 13.452 16.964 13.738 16.935 14.0227C16.9142 14.2413 16.8714 14.4572 16.8071 14.6673C16.7503 14.8396 16.6707 15.0037 16.5703 15.1553C16.4723 15.2931 16.3574 15.4182 16.2281 15.5278C15.7871 15.8267 15.2569 15.9685 14.7241 15.9302C14.286 15.9224 13.852 15.8457 13.4382 15.7029C12.9903 15.5583 12.566 15.35 12.1786 15.0845V18.4933C13.1128 18.8843 14.1201 19.0747 15.1339 19.0522C16.9162 19.0522 18.2397 18.584 19.1045 17.6476C19.9693 16.7113 20.3979 15.2993 20.3904 13.4118V0H16.9763V13.1659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.4404 3.14804H12.393V0H0V18.6275H3.4404V10.64H11.7763V7.46588H3.4404V3.14804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.9812 14.6599H42.8678V18.7356H46.9812V14.6599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.6865 1.60565C37.3826 1.39057 37.0634 1.19759 36.7314 1.0282C36.4196 0.868417 36.0982 0.727823 35.7689 0.607217C35.4702 0.495087 35.1651 0.400543 34.8552 0.32408L34.231 0.201139C33.9896 0.160489 33.7461 0.133127 33.5016 0.119178L32.7947 0.0856487L32.242 0.0595703C32.0766 0.0595703 31.866 0.0595703 31.6592 0.0595703H24.5641V18.687H31.4938C32.768 18.707 34.0395 18.563 35.2763 18.2586C36.3645 17.9479 37.369 17.4006 38.2166 16.6566C40.1167 15.0373 41.0655 12.6045 41.063 9.35839C41.063 6.35316 40.2232 4.0297 38.5438 2.388C38.2857 2.09895 37.9984 1.83681 37.6865 1.60565ZM34.7913 14.8796C34.5412 15.0188 34.278 15.1336 34.0054 15.2223C33.736 15.3075 33.459 15.3674 33.1782 15.4011C32.4297 15.49 31.6761 15.5298 30.9222 15.5204H27.9744V3.22624H31.6178C31.9111 3.22624 32.148 3.22624 32.321 3.24859C32.8297 3.27717 33.3339 3.3596 33.825 3.49447C36.1386 4.17499 37.2967 6.1433 37.2992 9.39937C37.2992 12.1612 36.4632 13.9879 34.7913 14.8796Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjdLogo);
export default __webpack_public_path__ + "static/media/fjd_logo.be2362bdbbca3df764608b6d0be46f24.svg";
export { ForwardRef as ReactComponent };